import { useEffect, useReducer } from "react";
import "../../../src/App.scss"; 
import AppRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { AuthContext } from "./context";
import { authReducer, initialState } from "../shift/modules/auth-module/reducer";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import http, { setAuthToken } from "../../axios";
import { changeThemee } from "../../shared/utils/theming";
import config from "../../environments/env-config";
import { ToastContainer } from "react-toastify";
import { getCookie } from "../../shared/utils/cookie";
import { useSelector, useDispatch } from "react-redux";
import { getIsLoading } from "./feature/common-slice";
import Syoverlayloader from "../../shared/components/sy-overlayloader";
import { initSocket } from "../../shared/socket";


const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (error.request) {
        // handle network error here
      }
    },
  }),
});



function App() {
  const dispatchRed = useDispatch();
  const isOverlayLoading = useSelector(getIsLoading);
  const [state, dispatch] = useReducer(authReducer, initialState);
  const contextData = { ...state, dispatch };

  useEffect(() => {
    async function prepare() {
      const authToken = getCookie(config.auth_token);
      // changeThemee(authTheme?.cy_themecolor);// future theming
      changeThemee('#1A9DD9');
      dispatch({
        type: "IS_READY",
        data: { authToken: authToken, isAppReady: true },
      });
      initSocket();
      authToken && setAuthToken(http("main_url") ,authToken);
    }
    prepare();
  }, []);

  if (!state.isAppReady) {
    return null;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthContext.Provider value={contextData}>
        <BrowserRouter>
          <ToastContainer />
          <Syoverlayloader loading={isOverlayLoading} />
          <AppRoutes />
        </BrowserRouter>
      </AuthContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
